'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionViewCarousel = function ActionViewCarousel(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 19h10V4H7v15zm-5-2h4V6H2v11zM18 6v11h4V6h-4z' })
  );
};
ActionViewCarousel = (0, _pure2.default)(ActionViewCarousel);
ActionViewCarousel.displayName = 'ActionViewCarousel';

exports.default = ActionViewCarousel;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/action/view-carousel.js
 ** module id = 1151
 ** module chunks = 0
 **/